export default __webpack_public_path__ + "static/media/goldfish.74c2992d.webm";